import { createWebSupportSearchEventFactory } from '@spotify-internal/ubi-sdk-support-spotify-com-web-support-search';
import { useMemo } from 'react';

import { useUbiContext } from '../ubiProvider';

export const useUbiSearch = () => {
  const ubiLogger = useUbiContext();
  const pageFactory = createWebSupportSearchEventFactory();

  return useMemo(
    () => ({
      logSearchInputFocus: () => ubiLogger.logInteraction(pageFactory.searchInputFactory().hitFocusInputField()),
      // `_articleSlug` is a compromise for the old search UBI spec on the homepage
      // The new search spec does not require it anymore
      logSearchResult: (_articleSlug: string, position: number) =>
        pageFactory.searchResultsListFactory().searchResultFactory({
          position,
        }),
      logSearch: (searchQueryString: string) =>
        ubiLogger.logInteraction(pageFactory.searchInputFactory().keyStrokeChangeSearchQuery({ searchQueryString })),
    }),
    [pageFactory, ubiLogger],
  );
};

export type UbiSearch = ReturnType<typeof useUbiSearch>;
